import { Banner, Box, Card, H2, Separator, Text } from '@betterment/samba-react';

import CopyableReferralKey from './CopyableReferralKey';
import OfferDetails from './OfferDetails';
import { useReferralSenderOffer } from './ReferAFriendProvider';
import SendInviteForm from './SendInviteForm';

const TRACKING_MODULE_NAME = 'ReferAFriendInvitationCard';

const ReferAFriendInvitationCard: React.FC = () => {
  const { referralFulfillments, maxReferralRewardCount } = useReferralSenderOffer();
  const remainingReferrals = maxReferralRewardCount - referralFulfillments;

  return (
    <Card css={{ p: 'space.400' }}>
      <Card.Header>
        <H2 variant="title200">Refer a friend</H2>
      </Card.Header>
      <Box css={{ py: 'space.300' }}>
        <Separator />
      </Box>
      <Card.Content>
        <Text as="p" css={{ mb: 'space.300' }}>
          Send an invite email or use your personalized link to refer a friend.
        </Text>
        <SendInviteForm trackingModule={TRACKING_MODULE_NAME} />
        <CopyableReferralKey trackingModule={TRACKING_MODULE_NAME} />
        {referralFulfillments > 0 && (
          <Banner variant="info" css={{ my: 'space.300' }}>
            {referralFulfillments >= maxReferralRewardCount ? (
              <Text
                as="p"
                css={{
                  marginBottom: 'space.0',
                }}
              >
                You have no more available rewards but you can continue referring friends.
              </Text>
            ) : (
              <Text
                as="p"
                data-testid="remaining-referrals"
                css={{
                  marginBottom: 'space.0',
                }}
              >
                <strong>{remainingReferrals}</strong> of {maxReferralRewardCount} referral rewards left
              </Text>
            )}
          </Banner>
        )}
      </Card.Content>
      <Card.Footer>
        <Box css={{ py: 'space.300' }}>
          <Separator />
        </Box>
        <OfferDetails trackingModule={TRACKING_MODULE_NAME} />
      </Card.Footer>
    </Card>
  );
};

export default ReferAFriendInvitationCard;
